import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslationService } from '@flexbenefits-ui/services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { Title } from '@angular/platform-browser';
import { MessagesComponent } from '@flexbenefits-ui/ui-components';

@Component({
  imports: [RouterModule, TranslateModule, HeaderComponent, MessagesComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit {
  protected title = 'flexbenefits-ui';
  private readonly translationService = inject(TranslationService);
  private readonly translateService = inject(TranslateService);
  private readonly titleService = inject(Title);

  ngOnInit(): void {
    // Set initial CSS variable for header height with fallback
    document.documentElement.style.setProperty('--header-height', '64px');

    // Set initial page title
    this.updatePageTitle();

    // Update page title when language changes
    this.translateService.onLangChange.subscribe(() => {
      this.updatePageTitle();
    });
  }

  private updatePageTitle(): void {
    this.translateService.get('app.title').subscribe((title: string) => {
      this.titleService.setTitle(title);
      console.log(`[App] Page title updated to: ${title}`);
    });
  }

  get currentLocale(): string {
    return this.translationService.getCurrentLocale();
  }

  get availableLocales(): string[] {
    return this.translationService.getAvailableLocales();
  }

  switchToEnglish(): void {
    this.translationService.setLocale('en');
  }

  switchToDutch(): void {
    this.translationService.setLocale('nl');
  }
}
